module.exports = __webpack_public_path__ + "static/media/logout-icon.354b658b.svg";